import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M797.1 64H226.9C136.9 64 64 136.9 64 226.9v570.2c0 90 72.9 162.9 162.9 162.9h570.2c90 0 162.9-72.9 162.9-162.9V226.9c0-90-72.9-162.9-162.9-162.9m0.1 529.5H593.5v203.7h-163V593.5H226.9v-163h203.6V226.9h162.9v203.6h203.8v163z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol